module.exports = __webpack_public_path__ + "img/01.ea16a700.jpg";